import React, {useEffect, useState} from 'react';
import PivotTableByWeek from './PivotTableByWeek';
import PivotTableByPeriod from "./PivotTableByPeriod";
import LoadingSpinner from "../Loading-Component/Loading";
import {Button} from "react-bootstrap";
import { authenticatedFetch } from '../../utils/api';

const ReportSummaryView = () => {
    const [viewMode, setViewMode] = useState('byPeriod');
    const [summaryData, setsummaryData] = useState([]);
    const [loading, setLoading] = useState(false);

    async function getSummaryTable() {
        setLoading(true);

        try {
            const res = await authenticatedFetch('/ManagerReport/GetSummaryData', {
                method: 'POST',
                body: JSON.stringify({}),
            });

            const result = await res.json();

            if (result.message != null) {
                setLoading(false);
                window.alert(result.item2);
                return;
            }

            setsummaryData(result.item1 || []);
            setLoading(false);
        }
        catch (ex) {
            console.log(ex);
            setLoading(false);
        }
    }

    useEffect(() => {
        getSummaryTable();
    }, []);

    const toggleView = () => {
        setViewMode((prev) => (prev === 'byPeriod' ? 'byWeek' : 'byPeriod'));
    };

    return (
        <>
            <LoadingSpinner loading={loading} />
            {summaryData.length > 0 ? (
                <>
                    <Button style={{ margin: '10px 10px 10px 5px' }} onClick={toggleView}>
                        {viewMode === 'byPeriod' ? 'By Period' : 'By Week'}
                    </Button>

                    {viewMode === 'byPeriod' ? (
                        <PivotTableByPeriod summaryData={summaryData} />
                    ) : (
                        <PivotTableByWeek filteredData={summaryData} />
                    )}
                </>
            ) : (
                <p>No Data</p>
            )}
        </>
    );
}

export default ReportSummaryView;
